﻿import { Outlet } from 'react-router-dom';
import NavBar from '../components/NavBar';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export default function MainLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <NavBar />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflowY: 'auto' }}>
        <Outlet />
      </Box>
    </Box>
  );
}
